import { useEffect } from "react";
import { Card, CardBody, Table } from "reactstrap";
import Moment from 'react-moment';

import { useAppDispatch, useAppSelector } from 'hooks/hooks';
import { getInvoices } from "services/invoice.service";
import { setGetMethod } from "reducers/dto.slice";

import { DEMO_EMAIL } from "appConstants";
import Paging from "components/shared/Paging";
import DataFilters from "components/shared/DataFilters";
import CopyData from "components/shared/CopyData";
import DownloadPdf from "components/shared/DownloadPdf";
import TableEmptyState from "components/shared/TableEmptyState";
import { setDemoInvoices } from "../reducers/invoice.slice";

const Invoices = () => {

    const customer = useAppSelector(x => x.customers.selectedCustomer);
    const invoices = useAppSelector(x => x.invoices.invoicesDto.items);
    const searchDto = useAppSelector(x => x.dtos.searchTransactionDto);
    const invoicesLoading = useAppSelector(x => x.invoices.loading);
    const invoicesError = useAppSelector(x => x.invoices.error);

    const dispatch = useAppDispatch();


    useEffect(() => {
        if (customer?.email === DEMO_EMAIL) {
            dispatch(setDemoInvoices());
        } else {

            dispatch(setGetMethod(getInvoices));
            dispatch(getInvoices(searchDto));
        }
    },
        [customer, dispatch, searchDto]);

    return (
        <Card className="shadow">
            <DataFilters />
            <CardBody>
                <Table bordered striped responsive className="bcd-data-table">
                    <thead>
                        <tr>
                            <th>
                                Date
                            </th>
                            <th>
                                Purchase Order
                            </th>
                            <th>
                                Invoice
                            </th>
                            <th>
                                Due Date
                            </th>
                            <th>
                                Serial Numbers
                            </th>
                            <th>
                                Status
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {invoices.length > 0 ? invoices.map(o => {
                            return (<tr key={o.transactionId}>
                                <td width="10%">
                                    <Moment format="MM/DD/YYYY">
                                        {o.transactionDate}
                                    </Moment>
                                </td>
                                <td width="15%">
                                    <DownloadPdf model={{ fileId: o.purchaseOrder || "", fileName: o.purchaseOrder || "", recordType: "purchaseOrder" }} />
                                </td>
                                <td width="10%">
                                    <DownloadPdf model={{ fileId: o.transactionId?.toString() || "", fileName: o.invoiceNumber || "", recordType: "invoice" }} />
                                </td>
                                <td width="10%">
                                    {o.dueDate &&
                                        <Moment format="MM/DD/YYYY">
                                            {o.dueDate}
                                        </Moment>}
                                </td>
                                <td className="m-auto">
                                    {o.serialNumbers &&
                                        <CopyData data={o.serialNumbers} />}
                                    {o.serialNumbers}
                                </td>
                                <td width="15%">{o.status}</td>
                            </tr>);
                        })
                            :
                            <TableEmptyState colSpan={6} isLoading={invoicesLoading} error={invoicesError} entityName="Invoices" />
                        }
                    </tbody>
                </Table>
                <Paging />
            </CardBody>
        </Card>
    );
}

export default Invoices;